// @ts-nocheck
import React from "react";
import { Card, CardContent } from "@/components/ui";
import { cn } from "@/lib/utils";
import { kpiDefs, iconBg } from "./sellerDetail.constants";

const fmtKPI = (key, val) => {
  if (key === "revenue30d") return `$${val.toLocaleString()}`;
  if (key === "refundRate") return `${val}%`;
  return String(val);
};

export const SellerKpiGrid = ({ kpis }) => (
  <div
    data-testid="seller-kpi-grid"
    className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-3 mb-8"
  >
    {kpiDefs.map((kpi) => {
      const Icon = kpi.icon;
      const val = kpis[kpi.key];
      const isNeg = val.delta.startsWith("-");
      return (
        <Card key={kpi.key} data-testid={`seller-kpi-${kpi.key}`}>
          <CardContent className="p-3">
            <div
              className={cn("p-1.5 rounded-md w-fit mb-2", iconBg[kpi.color])}
            >
              <Icon className="w-3.5 h-3.5" strokeWidth={1.5} />
            </div>
            <p className="text-lg font-bold text-slate-900 dark:text-slate-100">
              {fmtKPI(kpi.key, val.value)}
            </p>
            <div className="flex items-center justify-between mt-1">
              <span className="text-[10px] text-slate-500 dark:text-slate-400">
                {kpi.label}
              </span>
              <span
                className={cn(
                  "text-[10px] font-medium",
                  isNeg ? "text-rose-500" : "text-emerald-500",
                )}
              >
                {val.delta}
              </span>
            </div>
          </CardContent>
        </Card>
      );
    })}
  </div>
);
